import { useEffect, useState } from "react";
import api from "../utils/axios";

interface Milestone {
  id?: number;
  required_referrals: number;
  reward: number;
}

const Milestones = () => {
  const [milestones, setMilestones] = useState<Milestone[]>([]);
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH ================= */
  const fetchMilestones = async () => {
    try {
      const res = await api.get("/getMilestones");

      setMilestones(res.data?.milestones || []);
      setEnabled(res.data?.enabled || false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchMilestones();
  }, []);

  /* ================= HANDLERS ================= */
  const addMilestone = () => {
    setMilestones([
      ...milestones,
      { required_referrals: 0, reward: 0 },
    ]);
  };

  const updateMilestone = (
    index: number,
    field: keyof Milestone,
    value: number
  ) => {
    const updated = [...milestones];
    updated[index][field] = value;
    setMilestones(updated);
  };

  const deleteMilestone = (index: number) => {
    setMilestones(milestones.filter((_, i) => i !== index));
  };

  /* ================= VALIDATION ================= */
  const validateMilestones = () => {
    for (let i = 1; i < milestones.length; i++) {
      if (
        milestones[i].required_referrals <=
          milestones[i - 1].required_referrals ||
        milestones[i].reward <= milestones[i - 1].reward
      ) {
        alert("Milestones must be increasing");
        return false;
      }
    }
    return true;
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    // if (!validateMilestones()) return;

    setLoading(true);

    try {
      await api.post("/updateMilestones", {
        enabled,
        milestones,
      });

      alert("Milestones saved");
    } catch (err) {
      alert("Failed to save");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-8">
      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold">
            Milestone Rewards
          </h1>
          <p className="text-sm text-gray-500">
            Manage treasure box reward system
          </p>
        </div>

        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
          />
          Enable System
        </label>
      </div>

      {/* LIST */}
      <div className="bg-white border rounded-2xl p-6 space-y-4">
        {milestones.map((m, index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-4 gap-4 border p-4 rounded-lg"
          >
            <div>
              <label className="text-sm">Referrals</label>
              <input
                type="number"
                value={m.required_referrals}
                onChange={(e) =>
                  updateMilestone(
                    index,
                    "required_referrals",
                    Number(e.target.value)
                  )
                }
                className="w-full border px-3 py-2 rounded-lg mt-1"
              />
            </div>

            <div>
              <label className="text-sm">
                Reward (Total)
              </label>
              <input
                type="number"
                value={m.reward}
                onChange={(e) =>
                  updateMilestone(
                    index,
                    "reward",
                    Number(e.target.value)
                  )
                }
                className="w-full border px-3 py-2 rounded-lg mt-1"
              />
            </div>

            {/* Derived Reward */}
            {/* <div>
              <label className="text-sm">
                Actual Reward
              </label>
              <div className="mt-2 font-semibold text-green-600">
                ₹
                {index === 0
                  ? m.reward
                  : m.reward - milestones[index - 1].reward}
              </div>
            </div> */}

            <div className="flex items-end">
              <button
                onClick={() => deleteMilestone(index)}
                className="bg-red-500 text-white px-4 py-2 rounded-lg"
              >
                Delete
              </button>
            </div>
          </div>
        ))}

        <button
          onClick={addMilestone}
          className="bg-gray-900 text-white px-4 py-2 rounded-lg"
        >
          + Add Milestone
        </button>
      </div>

      {/* SAVE */}
      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={loading}
          className="bg-black text-white px-6 py-2 rounded-lg"
        >
          {loading ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default Milestones;